import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", testid }) => (
    <motion.div
        data-testid={testid}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.75, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, tone = "dark" }) => (
    <p
        className={`font-mono text-[11px] font-medium uppercase tracking-[0.28em] ${
            tone === "dark" ? "text-crimson" : "text-crimson"
        }`}
    >
        {children}
    </p>
);
